





































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'
import { onlyFloat } from '@/utils/common'

@Component
export default class ModalPlanosIncluir extends Vue {
  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  loadAddRegraCalculoOperadora: boolean = false
  get loadingAddRegraCalculoOperadora() { return this.loadAddRegraCalculoOperadora }
  set loadingAddRegraCalculoOperadora(value: boolean) { this.loadAddRegraCalculoOperadora = value }

  get showModalAddPlanos() { return this.getRegrasDeCalculoStore.modal.plano }
  set showModalAddPlanos(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'plano', value }) }

  get selectedAbrangencia() { return this.getRegrasDeCalculoStore.selectedAbrangencia }
  set selectedAbrangencia(value: any) { this.getRegrasDeCalculoStore.setSelectedAbrangencia(value) }

  get fatorPlano() { return this.getRegrasDeCalculoStore.fatorPlano }
  set fatorPlano(value: any) { this.getRegrasDeCalculoStore.setFatorPlano(value) }

  get abrangencia() { return this.getRegrasDeCalculoStore.planosAbrangencia }

  valorGarantiaMinimaRule = (value: any) => !!value || 'O valor é obrigatório.'
  onlyFloatUtil(value: number) { return onlyFloat(value) }

  async addProcedimento() {
    this.loadingAddRegraCalculoOperadora = true
    const request = await this.getRegrasDeCalculoStore.addPlano()
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingAddRegraCalculoOperadora = false
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Procedimento incluído com sucesso. ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingAddRegraCalculoOperadora = false
    this.showModalAddPlanos = false
  }

  @Watch('showModalAddPlanos')
  onChangeShowModalAddRegraCalculoOperadora(value: boolean) {
    if (!value) {
      this.getRegrasDeCalculoStore.setSelectedAbrangencia('')
    }
  }
}
